<template>
    <el-dialog title="查看失败记录" :visible.sync="dialog.visible" custom-class="table-dialog">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="id" label="编号"> </el-table-column>
            <el-table-column prop="collection_code" label="收款编号"> </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pagination.page"
                :page-sizes="[15, 20, 30, 50]"
                :page-size="pagination.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagination.total"
            >
            </el-pagination>
        </div>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: {
                visible: false
            },
            query: {
                batch_no: ''
            },
            tableData: [],
            pagination: {
                page: 1,
                limit: 15,
                total: 0
            }
        };
    },
    methods: {
        getTableData(batchNo) {
            //获取表格列表
            let _this = this;
            _this.tableData = batchNo;
            this.dialog.visible = true;
  
        },
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData(this.query.batch_no);
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData(this.query.batch_no);
        }
    }
};
</script>

<style>
.table-dialog{
    height: 60vh;
    overflow: auto;
}
</style>